import { apiClient } from '@/lib/apiClient';

import type { Coprocultivo, CoprocultivoCreate, CoprocultivoUpdate } from './types';

const base = (uidProtocolo: string) => `/protocolos/${uidProtocolo}/analisis-coprocultivo`;

export const coprocultivoApi = {
  async create(
    uidProtocolo: string,
    data: CoprocultivoCreate,
    signal?: AbortSignal
  ): Promise<Coprocultivo> {
    const response = await apiClient.post<Coprocultivo>(base(uidProtocolo), data, { signal });
    return response.data;
  },

  async listByProtocolo(uidProtocolo: string, signal?: AbortSignal): Promise<Coprocultivo[]> {
    const response = await apiClient.get<Coprocultivo[]>(base(uidProtocolo), { signal });
    return response.data;
  },

  async getById(
    uidProtocolo: string,
    uidAnalisis: string,
    signal?: AbortSignal
  ): Promise<Coprocultivo> {
    const response = await apiClient.get<Coprocultivo>(
      `${base(uidProtocolo)}/${uidAnalisis}`,
      { signal }
    );
    return response.data;
  },

  async update(
    uidProtocolo: string,
    uidAnalisis: string,
    data: CoprocultivoUpdate,
    signal?: AbortSignal
  ): Promise<Coprocultivo> {
    const response = await apiClient.patch<Coprocultivo>(
      `${base(uidProtocolo)}/${uidAnalisis}`,
      data,
      { signal }
    );
    return response.data;
  },

  async remove(uidProtocolo: string, uidAnalisis: string, signal?: AbortSignal): Promise<void> {
    await apiClient.delete(`${base(uidProtocolo)}/${uidAnalisis}`, { signal });
  },
};
